import React from "react";
import { Outlet, useOutletContext } from "react-router-dom";

import { Layout } from "../../../components/styleguide";

import styles from "./styles.module.less";

const QuestionnairesLayout = () => {
  const { id, forum } = useOutletContext();

  return (
    <div className={styles.container}>
      <Layout.Content>
        <Outlet context={{ id, forum }} />
      </Layout.Content>
    </div>
  );
};

export default QuestionnairesLayout;
